import { render, staticRenderFns } from "./BaseNavbar.vue?vue&type=template&id=48fbcaa6&scoped=true"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"
import style0 from "./BaseNavbar.vue?vue&type=style&index=0&id=48fbcaa6&prod&scoped=true&lang=css"
import style1 from "./BaseNavbar.vue?vue&type=style&index=1&id=48fbcaa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbcaa6",
  null
  
)

export default component.exports